// extracted by mini-css-extract-plugin
module.exports = {"title":"room_price_breakdown_title__DFBe2"};